import { IconButton } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { restart } from "../features/adaptability/adaptabilitySlice";
import { Button, TextField, Container, Grid } from "@mui/material";
import SubHeaderNav from "../components/SubHeaderNav";

export const RoxarHeader = () => {
  let currentPath = useLocation().pathname;
  const dispatch = useDispatch();

  let history = useHistory();

  const handleClick = () => {
    history.push("/");
    return dispatch(restart());
  };

  return (
    <>
      <div className='roxar_header'>
        <Container maxWidth='xl'>
          <div className='roxar_header_title'>
            <h1>Herramienta de optimización de plataformas de pozos en tierra</h1>
            {(currentPath !== "/" && currentPath !== '/index.html')&& (
              <IconButton title="Comenzar de Nuevo" onClick={() => handleClick()}>
                <ReplayIcon fontSize='large' sx={{ color: "white" }} />
              </IconButton>
            )}
            {(currentPath === "/" || currentPath === '/index.html') && (
             <a target='_self' 
            //  href="https://q.tools.measurementinstrumentation.com/flow/roxar-multiphase-roi-calculator/index.html" 
             href="../en/index.html" 
             >EN</a>
            )}
          </div>
        </Container>
      </div>
      {currentPath !== "/" && ( 
        <div className='subheader_nav_container'>
          <SubHeaderNav />
        </div>
      )}
    </>
  );
};
